import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zUserSnippet } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  type: z.enum(["all", "active", "past"]),
});

const responseSchema = z.array(zUserSnippet);

export default {
  method: HttpMethodEnum.GET,
  paramsType: HttpParamsTypeEnum.QUERY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
